import { AppState } from '../models/state/appState';

/**
 * Selected the directly-available command type state.
 * @param state
 */
export function selectDirectlyAvailableCommandTypes(state: AppState) {
  return state.sims.directlyAvailableCommandTypes;
}
